import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d27e54b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d27e54b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d27e54b')) {
      api.createRecord('0d27e54b', component.options)
    } else {
      api.reload('0d27e54b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0d27e54b&scoped=true&", function () {
      api.rerender('0d27e54b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inbox/grid/index.vue"
export default component.exports